import FingerprintJS from '@fingerprintjs/fingerprintjs-pro';

class NovaShield {
    constructor() {
        this.fingerprintJsOptions = { 
            apiKey: null, 
            region: null,
            endpoint: [
                "https://metrics.novashield.io",
            ]
        };
    }

    /**
     * Initializes the NovaShield instance with the required API key and optional region.
     * This method should be used to configure the instance before using it.
     *
     * @param {string} apiKey - The NovaShield public API key (required).
     * @param {string} region - The region (default is 'us').
     * @returns {NovaShield} - A configured instance of NovaShield.
     * @throws {Error} - Throws an error if the API key is not provided.
     */
    static init(apiKey, region = 'us') {
        if (!apiKey) {
            throw new Error('API key is required to initialize NovaShield.');
        }

        const instance = new NovaShield();
        
        instance.fingerprintJsOptions.apiKey = apiKey;
        instance.fingerprintJsOptions.region = region;

        return instance;
    }

    /**
     * Fetches device fingerprinting information.
     *
     * @returns {Promise<string|null>} - Resolves with the request ID if available, or null if not.
     * @throws {Error} - Throws an error if the instance is not initialized with an API key.
     */
    async lookupDevice() {
        if (!this.fingerprintJsOptions.apiKey) {
            throw new Error('NovaShield is not initialized. Call init() first.');
        }

        // Load the FingerprintJS library with the provided options
        const fpPromise = await FingerprintJS.load(this.fingerprintJsOptions);

        // Get the device fingerprinting result
        const result = await fpPromise.get();

        // Return the request ID if present, otherwise null
        return result?.requestId || null;
    }
}

export default NovaShield;